(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[711],{

/***/ 43131:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tin-tuc/[slug]",
      function () {
        return __webpack_require__(56599);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 11775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AB": function() { return /* binding */ useFetchNewsArticles; },
/* harmony export */   "G9": function() { return /* binding */ useFetchNewsArticle; },
/* harmony export */   "aC": function() { return /* binding */ useFetchNewsArticlesCount; },
/* harmony export */   "cW": function() { return /* binding */ DEFAULT_FETCHING_NEWS_OPTIONS; }
/* harmony export */ });
/* unused harmony exports fetchNewsArticle, fetchNewsArticles, fetchNewsArticlesCount */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _var_www_zemor_vn_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _var_www_zemor_vn_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_var_www_zemor_vn_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67848);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85945);
/* harmony import */ var _fetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36203);
/* harmony import */ var _queryKeys__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76296);







var DEFAULT_STALE_TIME = 1000 * 60 * 30; // 30 min
var DEFAULT_FETCHING_NEWS_OPTIONS = {
    limit: 8,
    page: 1,
    condition: {
        ngon_ngu: "vi",
        loai_tin_tuc: "Tin tức c\xe0 ph\xea"
    }
};
var fetchNewsArticle = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_var_www_zemor_vn_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(slug) {
        return _var_www_zemor_vn_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncGetItem */ .p9)({
                        collection_name: "news",
                        options: {
                            shared: true,
                            condition: {
                                slug: slug
                            }
                        }
                    });
                case 2:
                    return _ctx.abrupt("return", _ctx.sent);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchNewsArticle(slug) {
        return _ref.apply(this, arguments);
    };
}();
var useFetchNewsArticle = function(slug) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .newsKeys.detail */ .w3.detail(slug), function() {
        return fetchNewsArticle(slug);
    }, {
        // staleTime: DEFAULT_STALE_TIME,
        enabled: !!slug
    });
};
/* -------------------------------------------------------------------------- */ var fetchNewsArticles = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_var_www_zemor_vn_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var options, _args = arguments;
        return _var_www_zemor_vn_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    options = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {};
                    _ctx.next = 3;
                    return (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncGetList */ .NE)({
                        collection_name: "news",
                        options: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                            page: 1,
                            limit: 8,
                            sort: {
                                stt: 1,
                                date_created: -1
                            }
                        }, options), {
                            condition: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                                isnews: true,
                                ngon_ngu: "vi",
                                shared: true
                            }, (options === null || options === void 0 ? void 0 : options.condition) || {})
                        })
                    });
                case 3:
                    return _ctx.abrupt("return", _ctx.sent);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchNewsArticles() {
        return _ref.apply(this, arguments);
    };
}();
var useFetchNewsArticles = function(options) {
    var queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_7__/* .useQueryClient */ .NL)();
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .newsKeys.list */ .w3.list(options), function() {
        return fetchNewsArticles(options);
    }, {
        enabled: !!options,
        staleTime: DEFAULT_STALE_TIME,
        onSuccess: function(newsArticles) {
            newsArticles.map(function(newsArticle) {
                queryClient.setQueriesData(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .newsKeys.detail */ .w3.detail(newsArticle === null || newsArticle === void 0 ? void 0 : newsArticle.slug), newsArticle);
            });
        }
    });
};
/* -------------------------------------------------------------------------- */ var fetchNewsArticlesCount = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_var_www_zemor_vn_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var options, locale, data, _args = arguments;
        return _var_www_zemor_vn_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    options = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {}, locale = _args.length > 1 ? _args[1] : void 0;
                    _ctx.next = 3;
                    return (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncGetList */ .NE)({
                        collection_name: "news",
                        options: {
                            count: true,
                            condition: {
                                ngon_ngu: locale,
                                isnews: true,
                                loai_tin_tuc: "Tin tức c\xe0 ph\xea"
                            }
                        }
                    });
                case 3:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", (data === null || data === void 0 ? void 0 : data.rows_number) || 0);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchNewsArticlesCount() {
        return _ref.apply(this, arguments);
    };
}();
var useFetchNewsArticlesCount = function(options, locale) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .newsKeys.count */ .w3.count((options === null || options === void 0 ? void 0 : options.condition) || {}), function() {
        return fetchNewsArticlesCount(options, locale);
    }, {
        enabled: !!options,
        staleTime: DEFAULT_STALE_TIME
    });
};


/***/ }),

/***/ 34964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22312);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56817);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21017);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(38623);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66137);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(95117);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);







var useStyles = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .createStyles */ .k)(function() {
    return {
        imageWrapper: {
            width: "100%",
            aspectRatio: "1.5",
            position: "relative"
        }
    };
});
function NewCard(param) {
    var item = param.item, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading;
    var classes = useStyles().classes;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .Card */ .Z, {
        shadow: "sm",
        p: 0,
        radius: "sm",
        sx: {
            height: "100%",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                scroll: false,
                href: "/tin-tuc/".concat(item === null || item === void 0 ? void 0 : item.slug) || 0,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Skeleton */ .O, {
                            visible: isLoading,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .Card.Section */ .Z.Section, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classes.imageWrapper,
                                    children: !isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: (0,_utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                                            src: item === null || item === void 0 ? void 0 : item.picture,
                                            size: "s"
                                        }),
                                        alt: "Norway",
                                        layout: "fill",
                                        objectFit: "contain"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Group */ .Z, {
                            p: "md",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Skeleton */ .O, {
                                    visible: isLoading,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                                        style: {
                                            letterSpacing: 1
                                        },
                                        transform: "uppercase",
                                        size: "sm",
                                        lineClamp: 2,
                                        weight: "500",
                                        children: (item === null || item === void 0 ? void 0 : item.title) || "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Skeleton */ .O, {
                                    visible: isLoading,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                                        size: "xs",
                                        children: new Date(item === null || item === void 0 ? void 0 : item.date_updated).toLocaleDateString(locale, {
                                            year: "numeric",
                                            month: "2-digit",
                                            day: "2-digit"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            (item === null || item === void 0 ? void 0 : item.thong_tin_km) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/images/khuyen_mai.png",
                style: {
                    width: 64,
                    top: -10,
                    right: -10,
                    position: "absolute"
                }
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (NewCard);


/***/ }),

/***/ 48285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _setup_locale_provider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59963);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38623);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93284);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95117);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);





function AppBreadcrumbs(param) {
    var items = param.items, isLoading = param.isLoading;
    var getLabel = (0,_setup_locale_provider__WEBPACK_IMPORTED_MODULE_1__/* .useLocalContext */ .u)().getLabel;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
        visible: isLoading,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Breadcrumbs */ .O, {
            children: items === null || items === void 0 ? void 0 : items.map(function(item, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: item.href || "#",
                    scroll: false,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                            color: "dark",
                            size: "sm",
                            lineClamp: index === items.length - 1 ? 1 : 2,
                            sx: {
                                width: index === items.length - 1 ? "fit-content" : "max-content"
                            },
                            children: getLabel(item.title)
                        })
                    })
                }, index);
            })
        })
    });
}
AppBreadcrumbs.propTypes = {
    items: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().array.isRequired)
};
/* harmony default export */ __webpack_exports__["Z"] = (AppBreadcrumbs);


/***/ }),

/***/ 56599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ NewsDetail; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dist/styled-jsx/style.js
var styled_jsx_style = __webpack_require__(60536);
var style_default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style);
// EXTERNAL MODULE: ./apis/queryFunctions/news.js
var queryFunctions_news = __webpack_require__(11775);
// EXTERNAL MODULE: ./common/components/Breadcrumbs.js
var Breadcrumbs = __webpack_require__(48285);
// EXTERNAL MODULE: ./common/Layout/Container/Container.js
var Container = __webpack_require__(6559);
// EXTERNAL MODULE: ./common/NewCard/index.js
var NewCard = __webpack_require__(34964);
// EXTERNAL MODULE: ./utils/sanitizeDOMData.js + 1 modules
var sanitizeDOMData = __webpack_require__(2559);
// EXTERNAL MODULE: ./utils/slugifyString.js
var slugifyString = __webpack_require__(91957);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Center/Center.js
var Center = __webpack_require__(9094);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(19236);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(62679);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Skeleton/Skeleton.js + 1 modules
var Skeleton = __webpack_require__(38623);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/MediaQuery/MediaQuery.js + 1 modules
var MediaQuery = __webpack_require__(18540);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Affix/Affix.js
var Affix = __webpack_require__(82846);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-viewport-size/use-viewport-size.js
var use_viewport_size = __webpack_require__(29355);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-resize-observer/use-resize-observer.js
var use_resize_observer = __webpack_require__(12185);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-window-scroll/use-window-scroll.js
var use_window_scroll = __webpack_require__(72128);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/tocbot/src/js/index.js
var js = __webpack_require__(92866);
var js_default = /*#__PURE__*/__webpack_require__.n(js);
;// CONCATENATED MODULE: ./pages/tin-tuc/[slug]/Toc.js







function Toc(_param) {
    var refresh = _param.refresh, style = (0,_object_without_properties/* default */.Z)(_param, [
        "refresh"
    ]);
    react.useEffect(function() {
        js_default().init({
            tocSelector: ".toc",
            contentSelector: ".post",
            headingSelector: "h1, h2, h3",
            hasInnerContainers: true,
            headingsOffset: 100,
            scrollSmoothOffset: -100
        });
        // window.setTimeout(refeshToc, 1000);
        // tocbot.refresh();
        return function() {
            js_default().destroy();
        };
    });
    react.useEffect(function() {
        var refeshToc = function refeshToc() {
            js_default().refresh();
        };
        window.setTimeout(refeshToc, 1000);
        return function() {
            window.clearTimeout(refeshToc);
        };
    }, [
        refresh
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
                className: "jsx-3de20730cf991180" + " " + (style && style.className != null && style.className || "toc")
            })),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "3de20730cf991180",
                children: ".toc{background-color:var(--content-bg-primary);border:1px solid var(--content-border);-webkit-border-radius:.25rem;-moz-border-radius:.25rem;border-radius:.25rem;padding:1rem;font-size:.875rem}.toc-list .toc-list{padding-left:1rem;padding-top:.5rem}.toc-list-item{padding-bottom:.5rem}.toc-list-item:last-child{padding-bottom:0}.toc-link{color:var(--text-secondary)}.is-active-link{color:var(--text-primary);font-weight:700}.is-collapsed{max-height:1e3px!important;overflow:hidden;-webkit-transition:all 300ms ease-in-out;-moz-transition:all 300ms ease-in-out;-o-transition:all 300ms ease-in-out;transition:all 300ms ease-in-out}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/tin-tuc/[slug]/index.page.js

















var __N_SSG = true;
function NewsDetail() {
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), notFound = ref1[0], setNotFound = ref1[1];
    var ref2 = (0,router.useRouter)(), slug = ref2.query.slug, locale = ref2.locale, asPath = ref2.asPath;
    var breadcrumbs = [
        {
            title: locale === "vi" ? "Trang chủ" : "Home",
            href: "/"
        },
        {
            title: locale === "vi" ? "Tin tức" : "News",
            href: "/tin-tuc"
        }, 
    ];
    var ref3 = (0,queryFunctions_news/* useFetchNewsArticle */.G9)(slug), detail = ref3.data, isFetched = ref3.isFetched;
    var ref4 = (0,queryFunctions_news/* useFetchNewsArticles */.AB)({
        limit: 8,
        page: 1,
        condition: {
            ngon_ngu: locale,
            loai_tin_tuc: "Tin tức c\xe0 ph\xea"
        }
    }), news = ref4.data;
    // console.log("detail", detail);
    var refSideBar = react.useRef(null);
    var ref5 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), rectSideBar = ref5[0], setRectSideBar = ref5[1];
    var ref6 = (0,use_viewport_size/* useViewportSize */.n)(), height = ref6.height, width = ref6.width;
    var ref7 = (0,use_resize_observer/* useElementSize */.h)(), rootRef = ref7.ref, rootHeight = ref7.height;
    var ref8 = (0,use_resize_observer/* useElementSize */.h)(), tocbotRef = ref8.ref, tocbotHeight = ref8.height;
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,use_window_scroll/* useWindowScroll */.b)(), 1), scroll = ref9[0];
    var ref10 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), runToc = ref10[0], setRunToc = ref10[1];
    react.useEffect(function() {
        if (!tocbotRef.current) return undefined;
        if (rootHeight > scroll.y + tocbotHeight) {
            tocbotRef.current.style.opacity = "1";
        } else {
            tocbotRef.current.style.opacity = "0";
        }
    }, [
        rootHeight,
        scroll,
        tocbotHeight
    ]);
    react.useEffect(function() {
        if (refSideBar) {
            var ref;
            var rect = refSideBar === null || refSideBar === void 0 ? void 0 : (ref = refSideBar.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect();
            setRectSideBar(rect);
        }
    }, [
        height,
        width,
        refSideBar
    ]);
    react.useEffect(function() {
        if (isFetched && !(detail === null || detail === void 0 ? void 0 : detail.title)) {
            setNotFound(/*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                    order: 3,
                    children: locale === "vi" ? "Tin tức kh\xf4ng tồn tại" : "News does not exist"
                })
            }));
        }
        if (isFetched && (detail === null || detail === void 0 ? void 0 : detail.title)) {
            var h1_elms = document === null || document === void 0 ? void 0 : document.querySelectorAll(".post h1");
            var h2_elms = document === null || document === void 0 ? void 0 : document.querySelectorAll(".post h2");
            var h3_elms = document === null || document === void 0 ? void 0 : document.querySelectorAll(".post h3");
            for(var i = 0; i < h1_elms.length; i++){
                h1_elms[i].setAttribute("id", (0,slugifyString/* default */.Z)(h1_elms[i].textContent));
            }
            for(var i1 = 0; i1 < h2_elms.length; i1++){
                h2_elms[i1].setAttribute("id", (0,slugifyString/* default */.Z)(h2_elms[i1].textContent));
            }
            for(var i2 = 0; i2 < h3_elms.length; i2++){
                h3_elms[i2].setAttribute("id", (0,slugifyString/* default */.Z)(h3_elms[i2].textContent));
            }
            setRunToc(true);
        }
    }, [
        isFetched,
        detail
    ]);
    if (notFound) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: locale === "vi" ? "Tin tức kh\xf4ng tồn tại" : "News does not exist"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        py: 20,
                        style: {
                            minHeight: "100%"
                        },
                        children: notFound
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: rootRef,
        className: "jsx-14be5de5b1ad77c5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    className: "jsx-14be5de5b1ad77c5",
                    children: detail === null || detail === void 0 ? void 0 : detail.title
                })
            }),
            detail && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: detail === null || detail === void 0 ? void 0 : detail.meta_title,
                description: detail === null || detail === void 0 ? void 0 : detail.meta_description,
                openGraph: {
                    title: (detail === null || detail === void 0 ? void 0 : detail.meta_title) || (detail === null || detail === void 0 ? void 0 : detail.title),
                    description: detail === null || detail === void 0 ? void 0 : detail.meta_description,
                    type: "article",
                    url: "".concat("https://vietthien.flexzen.app").concat(asPath),
                    article: {
                        publishedTime: detail === null || detail === void 0 ? void 0 : detail.date_created,
                        modifiedTime: detail === null || detail === void 0 ? void 0 : detail.date_updated,
                        tags: (detail === null || detail === void 0 ? void 0 : (ref = detail.meta_keywords) === null || ref === void 0 ? void 0 : ref.split(" ")) || []
                    },
                    images: [
                        {
                            url: "".concat("https://api.flexzen.app").concat(detail === null || detail === void 0 ? void 0 : detail.picture),
                            alt: detail === null || detail === void 0 ? void 0 : detail.title
                        }, 
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                id: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                    py: 20,
                    style: {
                        minHeight: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                            items: (0,_to_consumable_array/* default */.Z)(breadcrumbs).concat([
                                {
                                    title: detail === null || detail === void 0 ? void 0 : detail.title,
                                    href: "#"
                                }
                            ]),
                            isLoading: !detail
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                    xs: 12,
                                    md: 9,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                        className: "jsx-14be5de5b1ad77c5",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                                mt: 10,
                                                mb: 10,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                                    visible: !detail,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                                                            order: 1,
                                                            size: "h5",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                                children: (detail === null || detail === void 0 ? void 0 : detail.title) || "B\xe0i viết kh\xf4ng tồn tại"
                                                            })
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                                mb: 10,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                                    visible: !detail,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                                        sx: {
                                                            display: "flex",
                                                            alignItems: "center"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                                size: "sm",
                                                                weight: "500",
                                                                children: (detail === null || detail === void 0 ? void 0 : detail.tac_gia) || locale === "vi" ? "ZEMOR" : "ZEMOR"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                                                mx: 5,
                                                                children: "|"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                                size: "sm",
                                                                children: new Date(detail === null || detail === void 0 ? void 0 : detail.date_updated).toLocaleDateString(locale, {
                                                                    year: "numeric",
                                                                    month: "2-digit",
                                                                    day: "2-digit"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "jsx-14be5de5b1ad77c5" + " " + "post webview",
                                                children: [
                                                    (0,sanitizeDOMData/* default */.Z)(detail === null || detail === void 0 ? void 0 : detail.content, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: "jsx-14be5de5b1ad77c5",
                                                        children: locale === "vi" ? "Tin tức kh\xe1c" : "Other news"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid */.r, {
                                                        children: news && detail ? news.filter(function(item) {
                                                            return item._id !== (detail === null || detail === void 0 ? void 0 : detail._id);
                                                        }).slice(0, 3).map(function(item) {
                                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                                                xs: 12,
                                                                sm: 4,
                                                                md: 4,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewCard/* default */.Z, {
                                                                    item: item
                                                                })
                                                            }, item === null || item === void 0 ? void 0 : item._id);
                                                        }) : Array(3).fill(undefined).map(function(item, i) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                                                xs: 12,
                                                                sm: 4,
                                                                md: 4,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewCard/* default */.Z, {
                                                                    item: item,
                                                                    isLoading: true
                                                                }, i)
                                                            }, i);
                                                        })
                                                    })
                                                ]
                                            }),
                                            !detail && Array(15).fill(undefined).map(function(item, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "jsx-14be5de5b1ad77c5",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                                            width: "50%",
                                                            height: 14,
                                                            my: 5
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                                            width: "70%",
                                                            height: 14,
                                                            my: 5
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                                            width: "100%",
                                                            height: 14,
                                                            my: 5
                                                        })
                                                    ]
                                                }, i);
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                    xs: 12,
                                    md: 3,
                                    ref: refSideBar,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQuery/* MediaQuery */.z, {
                                        smallerThan: "md",
                                        styles: {
                                            display: "none"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Affix/* Affix */.D, {
                                            position: {
                                                top: "140px",
                                                left: "".concat(rectSideBar === null || rectSideBar === void 0 ? void 0 : rectSideBar.left, "px")
                                            },
                                            zIndex: 10,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                ref: tocbotRef,
                                                className: "jsx-14be5de5b1ad77c5",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Toc, {
                                                    style: {
                                                        width: rectSideBar === null || rectSideBar === void 0 ? void 0 : rectSideBar.width
                                                    },
                                                    refresh: Boolean(runToc && (rectSideBar === null || rectSideBar === void 0 ? void 0 : rectSideBar.width))
                                                })
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "14be5de5b1ad77c5",
                children: ".sideBar{-webkit-box-flex:0;-webkit-flex:0 0 240px;-moz-box-flex:0;-ms-flex:0 0 240px;flex:0 0 240px}.sideBar-sticky{position:-webkit-sticky;position:sticky;top:2rem}"
            })
        ]
    });
};


/***/ }),

/***/ 91957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ slugify; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82670);

function convert_vi_to_en(str) {
    if (!(typeof str === "string" || (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(str, String))) return "";
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
    str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
    str = str.replace(/Đ/g, "D");
    str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
    str = str.replace(/  +/g, " ");
    return str;
}
function slugify(string) {
    var denicodeString = convert_vi_to_en(string);
    return denicodeString.toString().normalize("NFKD").toLowerCase().trim().replace(/\s+/g, "-").replace(/[^\w\-]+/g, "").replace(/\-\-+/g, "-");
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7323,9774,2888,179], function() { return __webpack_exec__(43131); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);